import React, {FC} from "react"
import styled, {css} from "styled-components"
import PropTypes from "prop-types"
import {Grid} from "react-bootstrap"

import authentication from "@irati/auth"
import {FormattedMessage} from "@irati/utils/lang"
import {useTheme} from "@irati/ui/src/global/useTheme"
import tracking from "@irati-tracking/homepage/homepage"
import History, {appOrContext} from "@irati/utils/history"
import {Row, Col} from "@irati/ui/src/ColumnRow"
import Banner from "@irati/ui/src/Banner"
import {Body, H2, Input} from "@irati/ui/src/Typography"
import bannerImg from "@irati-web/recognition/src/images/recognition-banner.png"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Card from "@irati/ui/src/Layout/Card"
import Spacing from "@irati/ui/src/Spacing"

const Container = styled.div`
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
`

const InputWrapper = styled.div`
  ${({theme}) => css`
    display: flex;
    align-items: center;
    border: 1px solid ${theme.colors.utility.subdued};
    border-radius: ${theme.border.radius.small};
    padding: ${theme.spacing.two};
    box-shadow: ${theme.shadows.low};
  `}
`

const CelebrationBanner: FC = (_, context) => {
  const theme = useTheme()
  const {apps} = context

  const isRecognitionEnabled = authentication.apps("recognition")

  const handleClick = () => {
    tracking.startCreateRecognition("homepage_recognition_banner")
    History.push(appOrContext({to: "/polls/create", app: apps.RECOGNITION}, context))
  }

  if (!isRecognitionEnabled) {
    return null
  }

  return (
    <Spacing onClick={handleClick} marginTop={5}>
      <Banner backgroundColor="transparent" bannerImg={bannerImg} minHeight={238} tabletMinHeight={238} radius={theme.border.radius.large}>
        <Container>
          <Grid>
            <Row>
              <Col xs={12} md={6} lg={4} paddingLeft={4}>
                <H2>
                  <FormattedMessage id="platform.homepage.lanes.celebration.title" />
                </H2>
                <Row>
                  <Col xsHidden smHidden sm={12}>
                    <Body large maxWidth="100%" marginBottom={1} color={theme.colors.utility.ink}>
                      <FormattedMessage id="platform.homepage.lanes.celebration.body" />
                    </Body>
                  </Col>
                </Row>
              </Col>

              <Col xs={12} md={6} lg={5} lgOffset={1}>
                <Card>
                  <InputWrapper>
                    <Icon icon={IconTypes.search} marginRight={2} />
                    <Input>
                      <FormattedMessage id="platform.homepage.lanes.celebration.input" />
                    </Input>
                  </InputWrapper>
                </Card>
              </Col>
            </Row>
          </Grid>
        </Container>
      </Banner>
    </Spacing>
  )
}

CelebrationBanner.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default CelebrationBanner
